let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bwJAI")).then(() => parcelRequire('bOcfK'));